import { useEffect, useState } from 'react';
import apiService from '../services/api';
import EmbedApiKeySection from './EmbedApiKeySection';
import '../styles/EmbedTesterNavbar.css';

const EmbedTesterNavbar = () => {
  const [user, setUser] = useState(null);
  const [school, setSchool] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const currentUser = await apiService.fetchCurrentUser();
        if (cancelled) return;
        setUser(currentUser);
        setSchool(currentUser?.active_school || null);
      } catch (error) {
        console.error('Failed to fetch embed tester user:', error);
        window.location.href = '/login/';
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleLogout = () => {
    apiService.logout();
    window.location.href = '/login/';
  };

  return (
    <header className="embed-tester-header">
      <div className="embed-tester-brand">
        <div className="embed-tester-school-logo">
          {!loading && school?.image ? (
            <img src={school.image} alt="" />
          ) : (
            <div className="embed-tester-school-logo-placeholder" />
          )}
        </div>
        <div>
          <div className="embed-tester-school-name">
            {loading ? 'Loading...' : (school?.name || 'School')}
          </div>
          <div className="embed-tester-portal-label">Embed Tester Portal</div>
        </div>
      </div>

      <div className="embed-tester-user">
        {user && (
          <div className="embed-tester-user-details">
            <div className="embed-tester-user-name">{user.first_name} {user.last_name}</div>
            <div className="embed-tester-user-email">{user.email}</div>
          </div>
        )}
        <button type="button" className="embed-tester-logout" onClick={handleLogout}>
          Log out
        </button>
      </div>
    </header>
  );
};

export default EmbedTesterNavbar;
